<template>
  <div id="app" :class="{ page_padding_top: showCommon }">
    <div class="app_top_box" v-if="showPage">
      <div class="app_header" v-if="showCommon">
        <HeaderView :pageConfig="pageConfig" ref="header_view" v-if="channelHeader == 'teach'"></HeaderView>
        <TrainHeaderView :pageConfig="pageConfig" ref="header_view" v-else-if="channelHeader == 'train'"></TrainHeaderView>
        <SelfExamHeaderView :pageConfig="pageConfig" ref="header_view" v-else-if="channelHeader == 'selfExam'"></SelfExamHeaderView>
      </div>
      <div class="app_wrap" ref="appWrap">
        <div class="app_content">
          <router-view
            @on-scroll="scrollToLocaltion"
            :pageConfig="pageConfig"
            @to_read="readEnd"
          />
        </div>
        <div class="app_bottom" v-if="showCommon">
          <BottomView :pageConfig="pageConfig"></BottomView>
        </div>
      </div>
    </div>
    <!-- 客服聊天组件 -->
    <!-- <CustomerServiceChat v-if="showCommon && isLoggedIn" /> -->
    <el-dialog
      title="用户隐私收集说明"
      :visible.sync="showPrivacyDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
    >
      <div style="white-space: pre-line;" class="tip_text_ys">
        为了向您提供更加便捷、高效的服务，本系统部分模块需要采集您的信息数据，并授权学校相关信息系统获得您所填写或留存在学校的身份信息（如姓名、照片、身份证号、学工号等信息）。这些信息将仅用于帮助您在学校不同的信息系统中更快捷地使用相应的服务。
      </div>
      <div style="white-space: pre-line;" class="tip_text_ys">
        您同意本协议并开始使用我们的服务后，我们将严格按照《中华人民共和国个人信息保护法》、《广东医科大学个人信息保护管理办法》及相关法律法规的要求，使用与保护您的个人信息。感谢您的信任与支持。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="countdown > 0 || submitting"
          @click="handleClick"
        >
          我已知晓
          <span v-if="countdown > 0">（{{ countdown }}s）</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import to from "await-to-js";
import api from "@/fetch/api";
import Cookies from "js-cookie";
import HeaderView from "@/components/common/HeaderView";
import TrainHeaderView from "@/components/common/train/TrainHeaderView";
import SelfExamHeaderView from "@/components/common/selfExam/SelfExamHeaderView";
import BottomView from "@/components/common/BottomView";
import CustomerServiceChat from "@/components/CustomerServiceChat";
import { setCookies, getCookies } from "@/utils/utils";
export default {
  name: "App",
  data() {
    return {
      pageConfig: {},
      showPage: false,
      showPrivacyDialog: false,
      countdown: 0,
      countdownTimer: null,
      submitting: false
    };
  },
  created() {
     if (sessionStorage.getItem('needRedirect')) {
        sessionStorage.removeItem('needRedirect');
        this.$router.replace({ path: "/" });
      }
    this.configView();
    this.getInitData();
    this.studentGetProfile();
  },
  mounted() {
    this.$nextTick(() => {
      top.window.SCROLLTOLOCALTION = this.scrollToLocaltion;
      setTimeout(() => {
        this.checkPrivacyDialog();
      }, 500);

    });
  },
  methods: {
    async studentGetProfile(){
      let _token = getCookies("token") || "";
      if (!_token) {
        this.showPage = true;
        return;
      }
      const [err, res] = await to(api.studentGetProfile());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        setCookies("userInfo", res.data);
        this.$store.dispatch("setUserInfo",res.data);
        this.showPage = true;
      }
    },
    // 检查是否需要弹出隐私弹窗
    checkPrivacyDialog() {
       console.log(1133)
       console.log(this.$route.name)
       if (this.$route.name === 'loginout') {
        return;
      }
      let _token = Cookies.get(`student_online_pc_token`) || "";
      if(!_token){
        return;
      }
      // 本地记忆key
      // 读取本地存储
      // firstLogin 从 vuex 获取
      const firstLogin =
        this.$store.state.userInfo && this.$store.state.userInfo.firstLogin;
      if (firstLogin === 1) {
        this.showPrivacyDialog = true;
        this.startCountdown();
      } else {
        this.showPrivacyDialog = false;
      }
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 5;
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    // 点击“我已知晓” agreePrivacy
    async handleClick() {
      if (this.countdown > 0 || this.submitting) return;
      this.submitting = true;
      // 调用接口通知服务端
      const [err, result] = await to(api.agreePrivacy());
      if (err) Promise.reject(err);
      if (result.code === 200) {
        // 关闭弹窗
        this.showPrivacyDialog = false;
      }
    },
    changeFavicon(iconUrl) {
      let link = document.querySelector("#logo_link");
      if (link) {
        link.href = iconUrl;
      } else {
        link = document.createElement("link");
        link.id = "logo_link";
        link.rel = "icon";
        link.href = iconUrl;
        document.head.appendChild(link);
      }
    },

    changeTitle(title) {
      document.title = title;
    },
    async configView() {
      const [err, res] = await to(api.configView());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.pageConfig = res.data;
        this.$store.dispatch("setSysSetting", res.data || {});
        let _url = "";
        if (res.data.logo) {
          _url = this.$imgUrl + res.data.logo;
        }
        this.changeFavicon(_url);
        this.changeTitle(`${res.data.schoolName}继续教育综合平台学生端`);
      } else {
        // this.$message.warning(res.msg);
      }
    },
    scrollToLocaltion(e) {
      this.$refs.appWrap.scrollTo(0, e);
    },
    getInitData() {
      let _token = getCookies("token") || "";
      let _studentInfo =
        (getCookies("userInfo") && JSON.parse(getCookies("userInfo"))) || {};
      let _formPage = getCookies("formPage") || "";
      if (_token) {
        if (_formPage !== "admin") {
          console.log('channel: '+this.channelHeader)
          if(this.channelHeader !== 'train' && this.channelHeader !== 'selfExam'){
            this.pageToWich(_studentInfo);
          }else{
            this.showPage = true;
          }

        } else {
          this.showPage = true;
        }
        this.$store.dispatch("getEnumsList");
        this.$store.dispatch("getDictList");
        this.$store.dispatch("getMyRoll");
        this.$store.dispatch("getMyStudent");
      } else {
        this.showPage = true;
      }
    },
    pageToWich(info) {
      if (info.firstLogin != 0) {
        // 1、密码未修改，进入密码修改页面
        this.showPage = true;
        this.$message.warning("系统检测到密码未修改,返回重新登录");
        setTimeout(() => {
          this.$router.push({ name: "loginout" });
        }, 1500);
      } else if (!info.electronicSignature) {
        // 2、未电子签名，进入电子签名
        this.showPage = true;
        this.$message.warning("系统检测到未电子签名,返回重新登录");
        setTimeout(() => {
          this.$router.push({ name: "loginout" });
        }, 1500);
      } else {
        this.mandatoryQuestionnaire();
      }
    },
    // 判断是否强制评价
    async mandatoryQuestionnaire() {
      const [err, res] = await to(api.mandatoryQuestionnaire());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        if (res.data) {
          this.$message.warning("系统检测到教学评价未完成,返回重新登录");
          setTimeout(() => {
            this.$router.push({ name: "loginout" });
          }, 1500);
        }
      }
      this.showPage = true;
    },
    readEnd() {
      this.$refs.header_view.courseNoticeUnRead();
    }
  },
  computed: {
    channelHeader() {
      return this.$store.state.auth;
    },
    firstLogin() {
      return this.$store.state.userInfo.firstLogin;
    },
    showSearch() {
      // return this.$route.name === "home" ? true : false;
      return false;
    },
    showCommon() {
      let _turnOff = false;
      let _routeName = this.$route.name;
      // 登录页和考试页面不显示公共头部和底部
      if (_routeName === "loginout" || _routeName === "onlineExaming") {
        _turnOff = false;
      } else {
        _turnOff = true;
      }
      return _turnOff;
    },
    // 是否已登录
    isLoggedIn() {
      let _token = getCookies("token") || "";
      return !!_token;
    }
  },
  components: {
    HeaderView,
    TrainHeaderView,
    SelfExamHeaderView,
    BottomView,
    CustomerServiceChat
  },
  watch: {
    // 监听 firstLogin 变化，动态检查弹窗
    firstLogin(newVal) {
      this.checkPrivacyDialog();
    },
    $route() {
      let appWrap = this.$refs.appWrap;
      appWrap && appWrap.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1400px;
  background: #e3eaf7;
  box-sizing: border-box;
  .app_header {
    position: fixed;
    top: 0; /* 元素固定在页面顶部 */
    left: 0;
    z-index: 9999999;
    width: 100%;
    box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
  }

  .app_wrap {
    min-height: calc(100vh - 70px);
    overflow-y: auto;
    background: #e3eaf7;

    .app_bottom {
    }
  }

  /*重置滚动条整体样式*/
  .app_wrap::-webkit-scrollbar {
    /*滚动条整体样式*/

    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/

    height: 15px;
  }

  .app_wrap::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/

    border-radius: 10px;

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    background: #2a303c;
  }

  .app_wrap::-webkit-scrollbar-track {
    /*滚动条里面轨道*/

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    border-radius: 10px;

    background: #ededed;
  }
}
.page_padding_top {
  padding-top: 70px;
}
.tip_text_ys {
  line-height: 28px;
  margin-bottom: 5px;
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue